import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	overflow: auto;
	padding: var(--padding-2) 0;

	&.editMode {
		max-height: 50dvh;

		@media ${Breakpoints.tablet} {
			max-height: unset;
		}
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	padding: 1rem 2rem;
	gap: 1rem;
`;

export const ShippingInformationFooter = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	padding: 2rem;
	gap: 1rem;
	box-shadow: 0px 1px 0px 0px var(--border-color) inset;
`;

export const FormContainer = styled.div`
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	padding: 0 var(--padding-3) 0 var(--padding-2);

	body[dir='rtl'] & {
		padding: 0 var(--padding-2) 0 var(--padding-3);
	}

	.alert {
		margin: 1rem;
	}

	> .form-item {
		flex: 1;

		@media ${Breakpoints.tablet} {
			flex: unset;
		}
	}

	@media ${Breakpoints.tablet} {
		padding: 0 var(--padding-2);
	}
`;

export const EmptyArea = styled.div`
	flex: 0 0 50px;

	@media ${Breakpoints.tablet} {
		flex: 0;
	}
`;

export const BoxContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	padding: 0 var(--padding-3);

	@media ${Breakpoints.tablet} {
		padding: 0 var(--padding-2);
	}
`;

export const BoxDividerLine = styled.div`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;
	margin: 2rem 1rem;
`;
